// @ts-ignore
import qs from 'qs';
import { fetchJson } from '@zapier/toolbox-browser-fetch';
import { Service } from '@zapier/services/esm/types';

type FetchServices = (url?: string | null | undefined) => Promise<Service[]>;

interface ImplementationsMeta {
  count: number;
  previous: string | null;
  next: string | null;
  results: Service[];
}

const fetchPublicServices: FetchServices = async () => {
  const url = '/api/v4/implementations-meta/public/';
  const { results }: ImplementationsMeta = await fetchJson(url);
  return results;
};

const fetchPrivateServices: FetchServices = async (
  nextUrl: string | null | undefined
) => {
  const queryString = qs.stringify({
    limit: 500,
  });
  const url = nextUrl || `/api/v4/implementations-meta/private/?${queryString}`;
  return await fetchJson(url);
};

type LoadServices = (
  onReceiveServices: Function,
  url?: string | null | undefined
) => Promise<void>;

export const loadPrivateServices: LoadServices = async (
  onReceivePrivateServices,
  url
) => {
  const privateServicesData = await fetchPrivateServices(url);
  onReceivePrivateServices(privateServicesData);
};

export const loadPublicServices: LoadServices = async onReceivePublicServices => {
  const publicServices = await fetchPublicServices();
  onReceivePublicServices(publicServices);
};
